import { render } from "./PdfUpload.vue?vue&type=template&id=6d34106c&scoped=true&ts=true"
import script from "./PdfUpload.vue?vue&type=script&lang=ts"
export * from "./PdfUpload.vue?vue&type=script&lang=ts"

import "./PdfUpload.vue?vue&type=style&index=0&id=6d34106c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d34106c"]])

export default __exports__